import type { TypeOf, ZodTypeAny } from "zod";

const getSafeSchemaParser = <T extends ZodTypeAny>(
    schema: T,
): ((value: unknown) => TypeOf<T> | undefined) =>
    function safeSchemaParser(value: unknown): TypeOf<T> | undefined {
        const parsed = schema.safeParse(value);
        return parsed.success ? (parsed.data as TypeOf<T>) : undefined;
    };

const parseSafely = <T extends ZodTypeAny>(params: {
    schema: T;
    value: unknown;
}): TypeOf<T> | undefined => {
    const { schema, value } = params;
    const parser = getSafeSchemaParser<T>(schema);
    return parser(value);
};

export { getSafeSchemaParser, parseSafely };
